import {AuthorizationMiddlewareContract} from 'common/http/AuthorizationMiddlewareContract';

export class AuthorizationMiddleware implements AuthorizationMiddlewareContract {
    public can(_action: string, _subject: string): void {
        // TODO
    }
}
